// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"1fc36fc1","57":"6a857164","615":"b880e92c","767":"cd5d4dc0"}[chunkId] + ".chunk.js";
};